import { Paragraph, AlignmentType } from 'docx'
import { ProcessingContext } from '../types'
import { processInlineFormatting } from './inlineFormatting'

/**
 * Process regular paragraph lines and return paragraph or null
 */
export function processParagraph(
  trimmedLine: string,
  context: ProcessingContext
): Paragraph | null {
  if (trimmedLine) {
    const processedRuns = processInlineFormatting(trimmedLine, context.font, context.fontSize)
    
    // Check if this looks like a contact info line (contains @ or |)
    if ((trimmedLine.includes('@') || trimmedLine.includes('|')) && !trimmedLine.startsWith('#')) {
      return new Paragraph({
        children: processedRuns,
        alignment: AlignmentType.LEFT,
        spacing: { after: 240 }
      })
    } else {
      return new Paragraph({
        children: processedRuns,
        spacing: { after: 120 }
      })
    }
  }
  return null
}